import { render, staticRenderFns } from "./CoatingAnalyzer.vue?vue&type=template&id=45aec0c5"
import script from "./CoatingAnalyzer.vue?vue&type=script&lang=js"
export * from "./CoatingAnalyzer.vue?vue&type=script&lang=js"
import style0 from "./CoatingAnalyzer.vue?vue&type=style&index=0&id=45aec0c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports